import { publicEnv } from '@/lib/config/public-env';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, type Stripe } from '@stripe/stripe-js';

const publishableKey = publicEnv('NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY');

// @stripe/stripe-js throws ("Cannot read properties of undefined (reading 'match')")
// when initialized without a publishable key. Skip init when the key is absent so a
// missing/unconfigured key doesn't crash every page; Elements accepts a null stripe.
const stripePromise: Promise<Stripe | null> | null = publishableKey
    ? loadStripe(publishableKey)
    : null;

export default function StripeProvider({ children }: { children: React.ReactNode }) {
    return <Elements stripe={stripePromise}>{children}</Elements>;
}
